export default __webpack_public_path__ + "static/media/BMWGroupSerif-Regular.3c8e4dbe.woff";